<template>
  <div class="auth" id="auth" name="auth">
    <div class="top">
      <NavTop activeIndex="4"></NavTop>
    </div>
    <div class="content-box" v-loading="loading">
      <el-form
        :model="LoginUser"
        status-icon
        ref="ruleForm"
        class="demo-ruleForm"
        style=""
      >
        <el-form-item prop="name" label="标题">
          <div
            class=""
            style="
              display: flex;
              display: flex;
              align-items: center;
              border: 1px solid #e6e6e6;
            "
          >
            <div class="" style="flex: 1">
              <el-input placeholder="请输入标题" v-model="title"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="name" label="类型">
          <div
            class=""
            style="
              display: flex;
              display: flex;
              align-items: center;
              border: 1px solid #e6e6e6;
            "
          >
            <el-select
              v-model="type"
              placeholder="请选择"
              @change="genderChang"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item prop="name" label="封面图">
          <el-upload
            class="upload-demo"
            action="https://476.new.lingchuang.co/api/common/upload"
            :on-success="onSuccess"
            :headers="headers"
            :show-file-list="false"
          >
            <div
              class=""
              style="display: flex; align-items: center; margin-top: 30px"
            >
              <img
                :src="thumb"
                alt=""
                style="width: 80px; height: 80px; border: 1px solid #ddd"
                v-if="thumb"
              />
              <div
                class=""
                style="
                  width: 80px;
                  height: 80px;
                  border: 1px solid #ddd;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 5px;
                  margin-right: 20px;
                "
                v-else
              >
                <i
                  class="el-icon-plus"
                  style="font-size: 40px; color: #ddd"
                ></i>
              </div>
              <div slot="tip" class="el-upload__tip">
                仅支持上传 .png .jpg .gif格式的文件
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="name" label="直播间">
          <div
            class=""
            style="
              display: flex;
              display: flex;
              align-items: center;
              border: 1px solid #e6e6e6;
            "
          >
            <el-select
              v-model="zhiboItem"
              placeholder="请选择"
              @change="zhiboChang"
            >
              <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.logoName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>

      <el-button
        size="medium"
        type="info"
        style="
          width: 270px;
          height: 40px;
          padding: 0;
          border-radius: 5px;
          background-color: #4b72f6;
          border: none;
          color: #666 !important;
        "
        round
        @click="submit"
        >确定开播</el-button
      >
    </div>
  </div>
</template>
<script>
import NavTop from "../components/NavTopWhit.vue";
import Cookies from "js-cookie";
import { openLive, getsaichenglist } from "../api/user";
export default {
  components: {
    NavTop,
  },
  data() {
    return {
      zhiboItem: "",
      title: "",
      type: "",
      options: [
        {
          value: "2",
          label: "篮球",
        },
        {
          value: "1",
          label: "足球",
        },
      ],
      thumb: "",
      headers: {
        token: localStorage.getItem("token"),
      },
      list: [],
      loading: false,
    };
  },
  created() {
    this.getzbList();
  },
  methods: {
    submit() {
      let data = {
        type: this.type,
        title: this.title,
        thumb: this.thumb,
        match_id: this.zhiboItem,
      };
      openLive().then((res) => {});
    },
    onSuccess(files, filList) {
      this.thumb = files.data.fullurl;
    },
    genderChang(e) {
      console.log(e);
      this.type = e;
    },
    zhiboChang(e) {
      console.log("直播的", e);
      this.zhiboItem = e;
    },
    getzbList() {
      this.loading = true;
      getsaichenglist({ date: this.time }).then((res) => {
        this.list = res.data;
        this.loading = false;
        this.list.forEach((item) => {
          item.logoName = item.leagueName.split("|")[0];
          item.home.logoName = item.home.name.split("|")[0];
          item.away.logoName = item.away.name.split("|")[0];
        });
      });
    },
  },
};
</script>
<style scoped>
.content-box {
  width: 1200px;
  margin: 80px auto 0;
  padding-top: 30px;
  background-color: #fff;
  min-height: 500px;
}

.el-form {
  width: 500px;
  margin: 0 auto;
  border: 1px solid #000;
}
</style>
